import { useHistoricalDashboardIds } from '../useHistoricalDashboardIds';
import { useSingleDashboard } from '../useSingleDashboard';

export function useLastUsedDashboard(options: Parameters<typeof useSingleDashboard>[1] = {}) {
  const { historicalDashboardIds } = useHistoricalDashboardIds();
  const lastDashboardId = historicalDashboardIds.at(-1);

  const { dashboard, ...rest } = useSingleDashboard(lastDashboardId!, { ...options, enabled: !!lastDashboardId });

  return { lastUsedDashboard: dashboard, ...rest };
}
